export default __webpack_public_path__ + "static/media/i-formas.6d3408f3.png";